import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import type { ProductGraph } from 'state/product-description/model';
import styled from 'styled-components';

const nbSkeletonRows = 10;
const nbSkeletonCols = 13;
const skeletonRowLoop = [...Array(nbSkeletonRows).keys()];
const skeletonColLoop = [...Array(nbSkeletonCols).keys()];

const StyledTable = styled.table`
  table-layout: fixed;

  thead > tr > th {
    font-size: 1.3rem !important;
    padding-top: var(--spacing-1);
    padding-bottom: var(--spacing-1);
  }

  tr {
    > th,
    > td {
      font-size: 1.3rem;
      vertical-align: middle;

      // Checkbox & status
      &:first-child,
      &:nth-child(2) {
        width: 2rem;
      }
      // Solve for
      &:nth-child(3) {
        width: 4rem;
        font-size: 1.8rem;
      }
      // Product
      &:nth-child(4) {
        width: 5rem;
      }
      // Sales counterpart
      &:nth-child(5) {
        width: 12rem;
      }
      // File code
      &:nth-child(6) {
        width: 3rem;
      }
      // ISIN
      &:nth-child(7) {
        width: 5rem;
      }
      // Strike date
      &:nth-child(8) {
        width: 5rem;
      }
      // Issue date
      &:nth-child(9) {
        width: 5rem;
      }
      // Add-on notional
      &:nth-child(10) {
        width: 10rem;
        font-size: 1.8rem;
      }
      // Offer price
      &:nth-child(11) {
        width: 4rem;
        font-size: 1.8rem;
      }
      // X margin
      &:nth-child(12) {
        width: 4rem;
        font-size: 1.8rem;
      }
      // Spot & Greeks
      &:nth-child(13) {
        width: 20rem;
      }
    }
  }
`;

export interface AddonManagementLoadingSkeletonProps {
  productDescription: ProductGraph;
}

export const AddonManagementLoadingSkeleton: FC = () => {
  return (
    <StyledTable
      data-e2e="addon-management-loading-skeleton"
      className="table table-sm table-addon-management bg-lvl1 mb-0 border-top"
    >
      <thead className="p-1">
        <tr>
          {skeletonColLoop.map(i => (
            <th key={i}>
              <Skeleton />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {skeletonRowLoop.map(i => (
          <tr key={i}>
            {skeletonColLoop.map(i => (
              <td key={i}>
                <Skeleton />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </StyledTable>
  );
};
